
































import { ROUTES, VAL_TYPES } from "@/configs";
import { Vue, Component } from "vue-property-decorator";
import { validateOperation } from "../apis";

@Component
export default class Validate extends Vue {
  valType = this.$route.params.valType;
  roomId = this.$route.params.roomId;
  error = "";
  loading = false;

  async mounted() {
    this.loading = true;

    try {
      const response = await validateOperation(
        this.valType as keyof typeof VAL_TYPES,
        this.roomId
      );

      if (response.ok)
        this.$router.push({
          path: ROUTES.room(this.roomId)
        });
      else this.error = response.data;
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  }

  onNavigateHome() {
    this.$router.push({ path: ROUTES.home });
  }
}
